import { CustomState } from "@affinity/Store/Reducers";
import { customDispatch } from "@affinity/Store/ServiceBase";
import ServiceRealTimePricing from "@affinity/Store/ServiceRealTimePricing";
import { AffinityProduct, HarrierPricingModel, PriceOptionViewModel, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
export interface PlaceOrderGetPricingParameters {
    selectedAddress: ShipToModel,
    selectedQuantity: number,
    selectedProduct: ProductModel | undefined
}

// Internal parameters
interface Props {
    pricingRaw: HarrierPricingModel,
    pricing: PriceOptionViewModel[],
    pricingCheapest: PriceOptionViewModel,
    pricingSoonest: PriceOptionViewModel,
}

type HandlerType = Handler<PlaceOrderGetPricingParameters, Props>;

const LoadPricing: HandlerType = async (props) => {
    const service = new ServiceRealTimePricing();
    const formattedAddress = props.parameter.selectedAddress.postalCode;

    if (props.parameter.selectedProduct) {
        props.pricingRaw = await service.getHarrierPricing(
            props.parameter.selectedProduct.id,
            props.parameter.selectedQuantity,
            props.parameter.selectedAddress.postalCode
        );
        props.pricing = service.mapRealTimePricing(props.pricingRaw);
    }else{
        throw new Error("Selected product not passed");
    }
}

const MapPricing: HandlerType = (props) => {
    props.pricingCheapest = props.pricing.sort((a, b) => (a.netUnitPrice - b.netUnitPrice))[0];
    props.pricingSoonest = props.pricing.sort((a, b) => (Number(a.deliveryBy) - Number(b.deliveryBy)))[0];
}

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/PlaceOrder/Pricing/Update",
        deliveryCheapest: props.pricingCheapest,
        deliverySoonest: props.pricingSoonest,
        hasAttemped: true,
        pricingRaw: props.pricingRaw,
    });

    (props.dispatch as customDispatch)({
        type: "Affinity/PlaceOrder/SetAddress",
        address: props.parameter.selectedAddress,
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    LoadPricing,
    MapPricing,
    UpdateState,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "PlaceOrderGetPricing");
export default createAccount;